export default __webpack_public_path__ + "static/media/yoga.25b97dc2.png";